function asOptions(data) {
    return data.items.map(item => `<option value="${item.id}">${item.text}</option>`).join("");
}

function t(data) {
    return `<select class='bookmark'>${asOptions(data)}</select>`;
}

export = t;  